import { watch } from 'vue'

import en from '../locales/en.json'
import i18n from '@/plugins/i18nPlugin.js'

const localeLoaders = import.meta.glob(['../locales/*.json', '!../locales/en.json'])

const supplierMessages = { en }

function mergeSupplierMessages(locale) {
  const messages = supplierMessages[locale]
  if (!messages) return
  if (i18n.global.getLocaleMessage(locale)?.ui?.supplier_portal) return
  i18n.global.mergeLocaleMessage(locale, messages)
}

mergeSupplierMessages('en')

const locale = i18n.global.locale.value

if (locale !== 'en') {
  localeLoaders[`../locales/${locale}.json`]?.().then((module) => {
    supplierMessages[locale] = module.default ?? module
    mergeSupplierMessages(locale)
  })

  watch(() => i18n.global.messages.value[locale], () => mergeSupplierMessages(locale))
}

export default i18n
